// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaEntityMapper$PorterinFeature from "../../../../shared/media/domain/entity-mappers/MediaEntityMapper.mjs";
import * as SharedEntityMapper$PorterinFeature from "../../../../shared/core/domain/entity-mappers/SharedEntityMapper.mjs";
import * as VehicleEntityMapper$PorterinFeature from "../../../../shared/vehicles/domain/entity-mapper/VehicleEntityMapper.mjs";

function getBannerImageEntity(model) {
  var img = model.image;
  if (img !== undefined) {
    return {
            path: img.url,
            alt_text: model.alt_text
          };
  } else {
    return MediaEntityMapper$PorterinFeature.getEmptyImage(undefined);
  }
}

function mapAdditionService(section) {
  return {
          text: section.text,
          sub_text: Belt_Option.getWithDefault(section.sub_text, ""),
          pointers: Belt_Array.map(section.pointers, (function (p) {
                  return {
                          text: p.text,
                          sub_text: p.sub_text,
                          icon: {
                            path: p.icon.src_path.url,
                            alt_text: p.icon.alt_text
                          }
                        };
                }))
        };
}

function getPnMHeroSection(data, banner) {
  if (data === undefined) {
    return {
            title: "",
            sub_text: "",
            know_more_cta: SharedEntityMapper$PorterinFeature.getKnowMoreCta({
                  label: "",
                  href: undefined
                }),
            banner_img: MediaEntityMapper$PorterinFeature.getEmptyImage(undefined),
            banner_img_mobile: MediaEntityMapper$PorterinFeature.getEmptyImage(undefined)
          };
  }
  var tmp;
  if (banner !== undefined) {
    var img = banner.banner_img;
    tmp = img !== undefined ? getBannerImageEntity(img) : MediaEntityMapper$PorterinFeature.getEmptyImage(undefined);
  } else {
    tmp = MediaEntityMapper$PorterinFeature.getEmptyImage(undefined);
  }
  var tmp$1;
  if (banner !== undefined) {
    var img$1 = banner.banner_img_mobile;
    tmp$1 = img$1 !== undefined ? getBannerImageEntity(img$1) : MediaEntityMapper$PorterinFeature.getEmptyImage(undefined);
  } else {
    tmp$1 = MediaEntityMapper$PorterinFeature.getEmptyImage(undefined);
  }
  return {
          title: data.title,
          sub_text: data.sub_text,
          know_more_cta: SharedEntityMapper$PorterinFeature.getKnowMoreCta(data.know_more_cta),
          banner_img: tmp,
          banner_img_mobile: tmp$1
        };
}

function getPnMCities(cities) {
  return Belt_Array.map(cities, (function (c) {
                var service_attrs = Belt_Array.map(c.services, (function (s) {
                        return {
                                attributes: {
                                  service_name: s.service_name,
                                  service_type: s.service_type,
                                  service_icon: {
                                    alt_text: s.service_icon.alt_text,
                                    image: {
                                      data: {
                                        attributes: s.service_icon.image
                                      }
                                    }
                                  }
                                }
                              };
                      }));
                return {
                        city_name: c.image.city_name.toLowerCase(),
                        city_image: MediaEntityMapper$PorterinFeature.getImageEntity(c.image.image),
                        city_label: c.image.city_label,
                        city_services: SharedEntityMapper$PorterinFeature.getVehicleServicesInfo(service_attrs)
                      };
              }));
}

function mapTestimonial(t) {
  return {
          customer_name: t.customer_name,
          city: t.city,
          testimonial_text: t.testimonial_text,
          rating: Belt_Option.getWithDefault(t.rating, 0.0),
          porter_service: t.porter_service
        };
}

function getInternalLinksSectionV2(model) {
  var data = model.data;
  if (data !== undefined) {
    return {
            text: data.attributes.text,
            link_section: Belt_Array.map(data.attributes.link_section, (function (link) {
                    return {
                            text: link.text,
                            links: Belt_Array.map(link.links, (function (link) {
                                    return {
                                            title: link.label,
                                            link: link.link
                                          };
                                  }))
                          };
                  }))
          };
  } else {
    return {
            text: "",
            link_section: []
          };
  }
}

function getInternalLinksSectionFlat(model) {
  if (model !== undefined) {
    return {
            text: model.text,
            link_section: Belt_Array.map(model.link_section, (function (linkGroup) {
                    return {
                            text: linkGroup.text,
                            links: Belt_Array.map(linkGroup.links, (function (link) {
                                    return {
                                            title: link.title,
                                            link: link.link
                                          };
                                  }))
                          };
                  }))
          };
  } else {
    return {
            text: "",
            link_section: []
          };
  }
}

function getPnMFaqsSection(model) {
  if (model === undefined) {
    return VehicleEntityMapper$PorterinFeature.getFaqsSection(undefined);
  }
  var d = model.data;
  if (d !== undefined) {
    return VehicleEntityMapper$PorterinFeature.getFaqsSection(d);
  }
  var fs = model.faqs_section;
  if (fs !== undefined) {
    return {
            title: fs.title,
            sub_text: fs.sub_text,
            faqs: SharedEntityMapper$PorterinFeature.getFaqs(fs.faqs),
            toggle_icon: MediaEntityMapper$PorterinFeature.getImageEntity(fs.toggle_icon)
          };
  } else {
    return VehicleEntityMapper$PorterinFeature.getFaqsSection(undefined);
  }
}

function getOtherServicesFromCityEntities(cities, city_name) {
  var city = Belt_Array.getBy(cities, (function (c) {
          return c.city_name.toLowerCase() === city_name.toLowerCase();
        }));
  if (city !== undefined) {
    return Belt_Array.map(city.city_services, (function (s) {
                  var match = s.service_type;
                  var tmp;
                  switch (match) {
                    case /* TwoWheelers */0 :
                        tmp = "two-wheeler";
                        break;
                    case /* Courier */6 :
                        tmp = "courier";
                        break;
                    case /* PackersMovers */7 :
                        tmp = "packers-and-movers";
                        break;
                    case /* Canter3Tonne */1 :
                    case /* Pickup1Tonne */2 :
                    case /* OneTon7Feet */3 :
                    case /* Trucks */4 :
                    case /* Compact */5 :
                    case /* Partload */8 :
                        tmp = "trucks";
                        break;
                    
                  }
                  var match$1 = s.service_type;
                  var tmp$1;
                  switch (match$1) {
                    case /* TwoWheelers */0 :
                        tmp$1 = "/two-wheelers";
                        break;
                    case /* Courier */6 :
                        tmp$1 = "/courier";
                        break;
                    case /* PackersMovers */7 :
                        tmp$1 = "/packers-and-movers";
                        break;
                    case /* Canter3Tonne */1 :
                    case /* Pickup1Tonne */2 :
                    case /* OneTon7Feet */3 :
                    case /* Trucks */4 :
                    case /* Compact */5 :
                    case /* Partload */8 :
                        tmp$1 = "/trucks";
                        break;
                    
                  }
                  return {
                          service_name: s.text,
                          service_type: tmp,
                          url: tmp$1,
                          service_icon: s.image
                        };
                }));
  } else {
    console.log("City not found, returning empty array");
    return [];
  }
}

function getOtherServices(cities, city_name, titleOpt, arrow_icon) {
  var title = titleOpt !== undefined ? titleOpt : "Other Services";
  var services = getOtherServicesFromCityEntities(cities, city_name);
  return {
          title: title,
          services: services,
          arrow_icon: arrow_icon
        };
}

var arrow_icon = {
  path: "https://dom-content-vault-prod-cdn-assets.porter.in/right_arrow_db54b8ed6d/right_arrow_db54b8ed6d.svg",
  alt_text: "arrow icon"
};

export {
  arrow_icon ,
  getBannerImageEntity ,
  mapAdditionService ,
  getPnMHeroSection ,
  getPnMCities ,
  mapTestimonial ,
  getInternalLinksSectionV2 ,
  getInternalLinksSectionFlat ,
  getPnMFaqsSection ,
  getOtherServicesFromCityEntities ,
  getOtherServices ,
}
/* VehicleEntityMapper-PorterinFeature Not a pure module */
